<template>
  <sub-page
      v-model="$store.state.settings.pageData"
      :title="$t('Faculties')"
      :subtitle="$t('Structure')"
      icon="mdi-account"
      :header-action="openNewInstitute"
      :header-action-text="$t('wsu.structure.faculty.add')"
      :no-content-condition="items.length === 0"
      :no-content-text="$t('wsu.structure.faculty.no_content')"
      :no-content-button-action="openNewInstitute"
      :no-content-button-text="$t('wsu.structure.faculty.add')"
      fill-height
  >

    <template #default >
      <ws-data-table
          :items="itemsFiltered"
          :headers="headers"
          :context-actions-select="contextActionsSelect"
          @itemSelect="selectedItem = $event"
          class="mt-5"
          :row-action="selectEntity"
      >
        <template #item.name="{item}">
          <h5 :style="`color : ${wsACCENT}`">{{ item.name }}</h5>
          <h5 class="font-weight-regular">{{ item.institute_name }}</h5>
        </template>

        <template #item.departments_count="{item}">
          <h5 class="text-center">{{ item.departments_count }}</h5>
        </template>

      </ws-data-table>
    </template>

    <template #dialog>
      <!--  AddEdit Faculty-->
      <ws-dialog
          v-model="displayDialog"
          :title="$t(!editEntity ? 'wsu.structure.faculty.add' : 'wsu.structure.faculty.edit')"
          @save="addInstitute"
          @delete="deleteFaculty"
          :confirm-delete-code="selectedItem ? selectedItem.uuid : null"
          :show-delete="editEntity"
      >

        <ws-text-field
            class="mt-6"
            v-model="entityData.name"
            :label="$t('wsu.structure.faculty.name.title')"
            :placeholder="$t('wsu.structure.faculty.name.placeholder')"
            :error="nameError"
            @input="nameError = false"
        />
        <v-expand-transition>
          <ws-select
              v-if="institutesSelect.length > 0 && $store.state.structure.selectedEntityType !== 'institute'"
              v-model="entityData.institute_id"
              :items="institutesSelect"
              :label="$t('Institute')"
              :placeholder="$t('wsu.structure.institute.choose')"
              class="pt-6"
              clearable
          />
        </v-expand-transition>

      </ws-dialog>
      <!--  Delete Faculty-->
      <ws-dialog
          v-if="displayDeleteDialog"
          v-model="displayDeleteDialog"
          @delete="deleteFaculty"
          :title="$t('wsu.structure.faculty.delete')"
          display-confirm-delete
          :confirm-delete-code="selectedItem ? selectedItem.uuid : null"
          close-delete
      />

    </template>

  </sub-page>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "specialties",
  data() {
    return {
      items : [],
      institutesSelect : [],
      displayDialog : false,
      entityData : {},
      selectedItem : {},
      displayDeleteDialog : false,
      editEntity : false,
      nameError : null
    }
  },
  computed : {
    ...mapState('avalon' , ['selectedLang']),
    ...mapState('structure' , ['selectedEntityType' , 'selectedEntityId' ]),

    headers() {
      return [
        { text : this.$t('Name') , value : 'name' },
        { text : this.$t('Departments') , value : 'departments_count' , width : 10 , align : 'center'}
      ]
    },
    itemsFiltered() {
      let items = this.items
      if ( this.selectedEntityType === 'institute' && this.selectedEntityId ) {
        items = items.filter(el => el.institute_id === this.selectedEntityId)
      }
      return items
    },
    contextActionsSelect() {
      return [
        { text : this.$t('Edit') ,
          value : 'edit' , icon : 'mdi-pencil' ,
          action : () => { this.openEditFaculty() } },
        { text : this.$t('Delete') ,
          value : 'delete' ,
          icon : 'mdi-delete-outline' ,
          action : () => { this.displayDeleteDialog = true }
        }
      ]
    }
  },
  methods : {
    ...mapActions('structure' , [
        'GET_FACULTIES' ,
        'ADD_FACULTY' ,
        'DELETE_FACULTY'
    ]),

    selectEntity(item) {
      this.$store.state.structure.returnEntityType.push(this.$store.state.structure.selectedEntityType)
      this.$store.state.structure.returnEntityId.push(this.$store.state.structure.selectedEntityId)
      this.$store.state.structure.returnEntityName.push(this.$store.state.structure.selectedEntityName)

      this.$store.state.structure.selectedEntityType = 'faculty'
      this.$store.state.structure.selectedEntityId = item.uuid
      this.$store.state.structure.selectedEntityName = item.name
      this.$router.push(this.businessDashLink(`structure/departments?entity=faculty&uuid=${item.uuid}&name=${item.name}`))
    },

    // AJAX
    async addInstitute() {

      if ( !this.entityData.name ) {
        this.nameError = true
        return this.notify(this.$t('wsu.structure.faculty.name.error') , 'warning')
      }

      this.entityData.lang = this.selectedLang

      let result = await this.ADD_FACULTY(this.entityData)
      if ( !result ) {
        this.notify(this.$t('NetworkError'))
        return
      }

      if ( !this.editEntity ) {
        this.items.push(result)
        this.notify(this.$t('wsu.structure.faculty.created') , 'success')
      } else {
        let index = this.items.findIndex(el => el.uuid === result.uuid )
        if (index === -1 ) {
          return
        }
        this.items[index] = result
        this.items = this.COPY(this.items)
        this.notify(this.$t('ChangesSaved'))
      }

      this.displayDialog = false
    },
    async deleteFaculty() {
      let result = await this.DELETE_FACULTY(this.selectedItem.uuid)
      if ( !result ) {
        return this.notify(this.$t('NetworkError'))
      }
      let index = this.items.findIndex(el => el.uuid === this.selectedItem.uuid )
      if (index === -1 ) {
        return
      }
      this.items.splice(index , 1)
      this.notify(this.$t('wsu.structure.faculty.deleted') )
      this.displayDeleteDialog = false
      this.displayDialog = false
    },
    // Methods
    openEditFaculty() {
      this.entityData = this.COPY(this.selectedItem)
      this.editEntity = true
      this.displayDialog = true
    },
    openNewInstitute() {
      this.editEntity = false
      this.entityData = {}

      if ( this.$store.state.structure.selectedEntityType === 'institute') {
        this.entityData.institute_id = this.$store.state.structure.selectedEntityId
      }

      this.displayDialog = true
    },
    // Technical
    async initPage() {
      let result = await this.GET_FACULTIES()
      this.items = result.faculties || []
      this.institutesSelect = result.institutes_select || []
    },
  },
  mounted() {
    this.initPage()
  }
}
</script>

<style scoped>

</style>